<template>
	<div>
		<vxe-modal :ref="modelRef" :style="{opacity: opacity}" v-model="boxShow" :width="width" :height="height"
			:title="boxtitle" show-footer @hide="hide" @close="close" @show="show" transfer :loading="loading" show-zoom>
			<template #default>
				<div style="padding: 10px;background-color: white;overflow: auto;">
					<vxe-grid v-bind="gridOptions" v-if="gridOptions && moduleName!=''" :ref="ref"
						:max-height="height-150" @toolbar-button-click="toolbarButtonClickEvent"
						@form-reset="formReset">
					</vxe-grid>
				</div>
			</template>
			<template #footer>
				<template v-if="footerShow">
					<vxe-button v-if="getFooterButton('submit')" size="mini" status="primary" content="确认"
						@click="submit(true)"></vxe-button>
					<vxe-button v-if="getFooterButton('submitandgoon') && selectType=='checkbox'" size="mini" status="success" content="确认并继续新增"
						@click="submit(false)"></vxe-button>
					<vxe-button v-if="getFooterButton('cancle')" size="mini" status="info" content="取消选择"
						@click="submitBlank"></vxe-button>
				</template>
			</template>
		</vxe-modal>
		<template v-if="buttonShow">
			<el-button class="" type="info" :icon="(!disabled && !readonly)?icon:'el-icon-lock'" @click.stop="alertBox"
				v-if="el" :status="disabled?'info':buttonsStatus" slot="reference" :size="size" :disabled="disabled">
			</el-button>
			<vxe-button class="" type="info" @click="boxShow=true" v-if="!el" slot="reference" :status="disabled?'info':buttonsStatus"
				:size="size" :disabled="disabled">{{text}}
			</vxe-button>
		</template>

	</div>
</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		top: -1px;
		width: 29px;
		padding: 7px 0px;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			customer: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			autoLoad: {
				type: Boolean,
				default: () => {
					return true
				}
			},			
			
			loading: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			footerButton: {
				type: Array,
				default: () => {
					return ['submit', 'submitandgoon', 'cancle']
				}
			},
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			group: {
				type: String,
				default: () => {
					return ''
				}
			},
			index: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			demo: {
				type: [Number, String],
				default: () => {
					return '2'
				}
			},
			selectType: {
				type: String,
				default: () => {
					return 'radio'
				}
			},
			title: {
				type: String,
				default: () => {
					return '请选择'
				}
			},
			width: {
				type: Number,
				default: () => {
					return 800
				}
			},
			height: {
				type: Number,
				default: () => {
					return 700
				}
			},
			trigger: {
				type: String,
				default: () => {
					return 'click'
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			text: {
				type: String,
				default: () => {
					return '查询'
				}
			},
			size: {
				type: String,
				default: () => {
					return 'mini'
				}
			},
			type: {
				type: String,
				default: () => {
					return 'text'
				}
			},
			el: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			placement: {
				type: String,
				default: () => {
					return 'bottom-start'
				}
			},
			buttons: {
				type: Array,
				default: () => {
					return ['confirm', 'cancle']
				}
			},
			parentControll: {
				type: Object,
				default: () => {
					return null
				}
			},
			icon: {
				type: String,
				default: () => {
					return 'el-icon-search'
				}
			},
			buttonsStatus: {
				type: String,
				default: () => {
					return 'primary'
				}
			},
			code: {
				type: String,
				default: () => {
					return ''
				}
			},
			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			readonly: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				boxtitle:'',
				componenttype: window.config.app,
				typeBuff: false,
				opacity: 1,
				boxShow: false,
				popoverDisabled: false,
				gridKey: Math.random(),
				gridOptions: null,
				visible: false,
				ref: Math.random(),
				modelRef: Math.random(),
				popoverRef: Math.random(),
				foreingKey: {},
				containerId: 'box_' + Math.random(),
				buttonShow: true,
				footerShow: true,
				pagerConfig: {
					currentPage: 1,
					pageSize: 20,
					enabled: true,
					pageSizes: [10, 20, 50, 100, 200, 500],
					force:false
				},
				treeConfig:{
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: false,
				},
				sourceData: [],
				device: window.systemMethods.device()
			}
		},
		created() {
			if (this.moduleName != '' && !this.disabled && !this.readonly) {
				if(!this.customer){
					this.initList()
				}
				
			}

		},
		watch: {
			title(e){
				this.boxtitle = e
			}
		},
		mounted() {
			if (this.store.box) {
				this.store.box[this.code] = this
			} else {
				let obj = {}
				obj[this.code] = this
				this.store.box = obj
			}
			this.boxtitle = this.title
			//this.store.table = this.$refs[this.ref]
		},
		methods: {
			initList() {
				if(!this.gridOptions){
					if (!this.$api[this.moduleName]) {
						this.$message.error('选择框:'+this.moduleName+'模块不存在')
						return
					}
					this.$api[this.moduleName].init({
						mode: 'box',
						group: this.group,
						index: this.index
					}).then((res) => {
						this.initBox(res)
					})
				}
			},
			initBox(res){
				
				if(res.pagerConfig && res.pagerConfig.length!=0 && !this.pagerConfig.force){
					this.pagerConfig = res.pagerConfig
				}
				let gridOptions = this.getOption()
				gridOptions.id = (this.moduleName?this.moduleName:'') + '_boxmodule',
				gridOptions.pagerConfig = this.pagerConfig
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.showHeaderOverflow = false
				gridOptions.showOverflow = false
				gridOptions.params = {
					mode: 'box',
					store: this.store
				}		
				if(res.columns){
					gridOptions.columns = this.getColumns(res.columns)
					gridOptions.formConfig = this.getForm(res.columns)			
				}
				if(res.buttons){
					gridOptions.toolbarConfig = this.getToolbar(res.buttons)
				}	
				// let labelField = ''
				// gridOptions.columns.forEach((item, index) => {
				// 	if (item.type != '' && labelField == '') {
				// 		labelField = gridOptions.columns[index].field
				// 	}
				// })
				gridOptions.cellStyle = this.cellStyle
				gridOptions.treeConfig =  this.treeConfig
				gridOptions.radioConfig = {
					//labelField: labelField,
					trigger: 'row',
					checkMethod: this.checkMethod,	
				}
				gridOptions.checkboxConfig = {
					//labelField: labelField,
					trigger: 'row',
					checkMethod: this.checkMethod,
					visibleMethod: this.visibleMethod,
			
				}	
				if (this.beforeCreateGrid) {
					this.beforeCreateGrid(gridOptions.formConfig, gridOptions.columns, gridOptions)
				}
				this.gridOptions = gridOptions
				this.ready()
			},

			list(page, form, other) {
				return new Promise((resolve, reject) => {
					this.$api[this.moduleName].list({
						mode: 'box',
						index: this.index,
						group: this.group,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						this.sourceData = JSON.parse(JSON.stringify(res
							.list))
							//console.log(this.sourceData,9090)
						this.$emit('boxdataload', {
							moduleName: this.moduleName,
							data: res.list
						})	

						resolve(res)
					}, () => {
						reject()
					})
				})
			},

			getToolbar(buttons) {
				let toolbarButton = []
				buttons.forEach((item) => {
					let obj = {}
					obj.code = item.code
					obj.status = item.status?item.status:'primary'
					obj.name = item.name
					obj.disabled = false
					obj.icon = ''
					toolbarButton.push(obj)
				})
				return {
					size: 'mini',
					perfect: false,
					buttons: toolbarButton
				}
			},
			getOption() {
				let list_getOption = this.list_getOption()
				this.list_gridOptions = list_getOption
				return list_getOption
			},
			getForm(data) {
				let items = []
				//let formdata = {}
				data.forEach((item) => {
					//formdata[item.field] = item.value?item.value:null
					if (item.render) {
						items.push({
							field: item.field,
							title: item.title,
							folding: items.length >= 4,
							size: 'mini',
							span: item.span?item.span:6,
							resetValue:item.resetValue,
							itemRender: {
								defaultValue:item.defaultValue,
								name: item.render,
								options: [],
								optionProps: {

								},
								props: {
									islist:true,
									name: item.name,
									size: 'mini',
									placeholder: '',
									...item.props
								},
							},
						})
					}
				})
				if (items.length != 0) {
					items.push({
						align: 'left',
						span: 24,
						itemRender: {
							name: '$tableformbutton',
							props:{
								//table:this
							}
						}
					})
				}
				// if (items.length != 0) {
				// 	items.push({
				// 		align: 'left',
				// 		span: '6',
				// 		itemRender: {
				// 			name: '$buttons',
				// 			children: [{
				// 				props: {
				// 					type: 'submit',
				// 					content: '查询',
				// 					status: 'primary'
				// 				}
				// 			}, {
				// 				props: {
				// 					type: 'reset',
				// 					content: '重置'
				// 				}
				// 			}]
				// 		}
				// 	})
				// }
				return {
					titleWidth: '80',
					titleAlign: 'center',
					items: items,
					//data:formdata
				}
			},
			getColumns(data) {
				let hasTreeNode = false
				let columns = []
				data.forEach((item) => {
					// let type = ''
					// if (index == 0 && item.visible !== false) {
					// 	if (!this.typeBuff) {
					// 		type = this.selectType
					// 		this.typeBuff = true
					// 	}
					// } else if (item.visible !== false) {
					// 	if (!this.typeBuff) {
					// 		type = this.selectType
					// 		this.typeBuff = true
					// 	}
					// } else {
					// 	type = ''
					// }
					let obj = {
						//type: type,
						width: item.width ? item.width : '',
						field: item.field,
						title: item.title,
						sortable: true,
						slots: item.slots,
						formatter: item.formatter ? ({
							row
						}) => {
							return window.systemMethods.formatter(row, item)
						} : null,
						visible: item.visible,
						treeNode: item.treeNode
					}
					if(item.penetrate){
						obj.slots = {
							default: ({row}) => {	
								return <el-link style="font-size:12px;" type="primary" onClick={(e)=>{this.penetrate(row,e)}} >{row[obj.field]}</el-link>
							}
						}
					}
					// if(item.){
						
					// }
					columns.push(obj)
					if(item.treeNode){
						hasTreeNode = true
					}
				})
				if(!hasTreeNode){
					this.treeConfig = null
				}
				if(this.selectType){
					columns.unshift({
						type:this.selectType,
						title:'#',
						width:50
					})
				}
				// if(this.selectType == 'checkbox'){

				// }
				return columns
			},
			penetrate(row,e){
				e.stopPropagation()
				this.$emit('boxdatapenetrate', {
					moduleName: this.moduleName,
					data: row
				})	
			},
			show() {			
				let handle = setInterval(()=>{
					if(this.getTable()){
						if(this.autoLoad){
							let fullData = this.getTable().getTableData().fullData
							if (fullData.length == 0) {
								this.getTable().commitProxy('query')
							}
						}					
						clearInterval(handle)
					}
				},100)
			},
			preLoadData() {
				if (!this.getTable()) {
					this.opacity = 0
					this.boxShow = true
					this.$nextTick(() => {
						this.boxShow = false
					})
				}
			},
			reload() {
				let form = this.getTable().getProxyInfo().form
				for (let i in form) {
					form[i] = null
				}
				this.getTable().commitProxy('reload')
				//console.log(this.foreingKey)
				//this.gridKey = Math.random()
			},
			setComponent(component) {
				this.component = component
				document.getElementById(this.containerId + '_id').appendChild(component.$el)
			},
			setForeingKey(foreingKey) {
				let table = this.getTable()
				this.foreingKey = foreingKey
				if (table) {
					table.reloadData([])
				}
			},

			getTable() {
				return this.$refs[this.ref]
			},
			close(close) {
				this.visible = false
				this.$refs[this.ref].clearCheckboxRow()
				// let form = this.$refs[this.ref].getProxyInfo().form
				// for(let i in form){
				// 	form[i] = null
				// }
				// this.$refs[this.ref].commitProxy('query')


				if (close) {
					this.$refs[this.modelRef].close()
					this.$emit('hide')
				}
			},
			formReset() {

			},
			toolbarButtonClickEvent(e) {
				if(this[e.code]){
					this[e.code]()
				}
			},
			ready() {

			},
			checkMethod() {
				return true
			},
			cellStyle(){

			},
			visibleMethod() {
				return true
			},
			hide() {

				this.$emit('hide')
			},
			submit() {

			},
			submitwidthreflash() {

			},
			submitBlank() {
				this.$refs[this.ref].clearRadioRow()
				this.$refs[this.ref].clearCheckboxRow()
				this.submit(true, 'clear')
			},
			alertBox() {
				if (!this.disabled && !this.readonly) {
					this.boxShow = true
				}

			},
			timestampToTime(timestamp) {
				let date = new Date(timestamp * 1000)
				let Y = date.getFullYear() + "-"
				let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-"
				let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " "
				// let h = date.getHours() + ":"
				// let m = date.getMinutes() + ":"
				// let s = date.getSeconds()
				return Y + M + D
			},
			setFieldRemain(obj, uniqueItem, objfield, boxfield, negotiable = false, boxdata = false, type = 'change') {
		//console.log(uniqueItem,22)
				let rowvalue = obj[objfield] ? parseInt(obj[objfield]) : 0
			
				let tableData = boxdata ? boxdata : this.getTable().getTableData().fullData
				let primaryvalue = {}
				for (let i in uniqueItem) {
					primaryvalue[uniqueItem[i]] = obj[i]
				}

				let sourcedata = this.sourceData.find((item) => {
					let buff = true
					for (let i in primaryvalue) {
						if (item[i] != primaryvalue[i]) {
							buff = false
						}
					}
					return buff
				})
				//console.log(primaryvalue,sourcedata,9090)
				let currenttableData = tableData.find((item) => {
					let buff = true
					for (let i in primaryvalue) {
						if (item[i] != primaryvalue[i]) {
							buff = false
						}
					}
					return buff
				})
				
				//console.log(type,sourcedata,currenttableData)
				if (sourcedata && currenttableData) {
					if (!obj[objfield + '_max'] && obj[objfield + '_max'] !== 0) {
						if (type == 'insert') {	
							//console.log(sourcedata['enable' + boxfield],123123)
							obj[objfield + '_max'] = sourcedata['enable' + boxfield]
						} else {
							obj[objfield + '_max'] = parseInt(sourcedata['enable' + boxfield]) + rowvalue
						}
						
					}
					//console.log(type,obj[objfield + '_max'],rowvalue)
					let max = obj[objfield + '_max']
					
					if (!negotiable) {
						obj[objfield + '_min'] = 0
						rowvalue = Math.max(0, Math.min(max, rowvalue))
					}
					
					if (type == 'delete') {
						sourcedata['enable' + boxfield] = max
						currenttableData['enable' + boxfield] = max
						
					} else {
						currenttableData['enable' + boxfield] = max - rowvalue
					}

				}
				obj[objfield] = rowvalue
				//console.log(rowvalue,primaryvalue,obj,1111111)
				//console.log(obj,objfield)
				return rowvalue

			},
			getFooterButton(code) {
				let index = this.footerButton.findIndex((item) => {
					return item == code
				})
				return index == -1 ? false : true
			}

		},
		components: {

		}
	}
</script>
